import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { takeWhile } from 'rxjs';
import {
  MCGRConservationPermitFormGroup,
  MCGRConstructionPermitFormGroup,
  MCGRPermitFormControlName,
} from '../services/new-request-form/new-request-form.model';
import {
  MCGRConservationPermit,
  MCGRConstructionPermit,
  MCGRConstructionPermitDocumentType,
} from '../services/new-request/new-request.model';

@Component({
  selector: 'app-mcgr-permit-section',
  templateUrl: './permit-section.component.html',
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, NgbModule],
})
export class MCGRPermitSectionComponent implements OnInit, OnDestroy {
  private isAlive = true;
  controlName = MCGRPermitFormControlName;
  constructionPermitDocumentType = MCGRConstructionPermitDocumentType;
  @Input() formGroup: FormGroup<
    MCGRConservationPermitFormGroup | MCGRConstructionPermitFormGroup
  >;
  @Input() submitted: boolean;
  @Input() sectionHeader: string;
  @Input() idPrefix = '';

  ngOnInit(): void {
    this.setProperValidatorsOnTypeChange();
  }

  setProperValidatorsOnTypeChange(): void {
    const typeFormControl = this.getTypeFormControl();
    if (!typeFormControl) {
      return;
    }
    const issuedByFormControl = this.getIssuedByFormControl();
    const numberFormControl = this.getNumberFormControl();
    const dateFormControl = this.getDateFormControl();
    typeFormControl.valueChanges
      .pipe(takeWhile(() => this.isAlive))
      .subscribe((type) => {
        issuedByFormControl.reset();
        numberFormControl.reset();
        dateFormControl.reset();
        dateFormControl.setValidators([Validators.required]);
        if (type === MCGRConstructionPermitDocumentType.BuildingPermit) {
          issuedByFormControl.setValidators([Validators.required]);
          numberFormControl.setValidators([Validators.required]);
        } else {
          issuedByFormControl.clearValidators();
          numberFormControl.clearValidators();
        }
        issuedByFormControl.updateValueAndValidity();
        numberFormControl.updateValueAndValidity();
      });
  }

  isTypeFormControlValid(): boolean {
    const typeFormControl = this.getTypeFormControl();

    return !typeFormControl || typeFormControl.valid;
  }

  getTypeFormControl(): AbstractControl {
    return this.formGroup.get(
      MCGRPermitFormControlName.Type,
    ) as AbstractControl;
  }

  isIssuedByFormControlValid(): boolean {
    return this.getIssuedByFormControl().valid;
  }

  getIssuedByFormControl(): AbstractControl {
    return this.formGroup.get(
      MCGRPermitFormControlName.IssuedBy,
    ) as AbstractControl;
  }

  isDateFormControlValid(): boolean {
    return this.getDateFormControl().valid;
  }

  getDateFormControl(): AbstractControl {
    return this.formGroup.get(
      MCGRPermitFormControlName.Date,
    ) as AbstractControl;
  }

  isNumberFormControlValid(): boolean {
    return this.getNumberFormControl().valid;
  }

  getNumberFormControl(): AbstractControl {
    return this.formGroup.get(
      MCGRPermitFormControlName.Number,
    ) as AbstractControl;
  }

  setFormFromData(data: MCGRConstructionPermit | MCGRConservationPermit): void {
    if (!data) {
      return;
    }
    if ('type' in data) {
      this.getTypeFormControl()?.setValue(data.type);
    }
    setTimeout(() => {
      this.getIssuedByFormControl()?.setValue(data.issuedBy);
      this.getDateFormControl()?.setValue(data.date);
      this.getNumberFormControl()?.setValue(data.number);
    });
  }

  ngOnDestroy(): void {
    this.isAlive = false;
  }
}
